import { checkLanguage } from "../../utils/setLanguage";
import { cache } from "../persistence/cache";

let currentProfile = null;

const update = function(newProfile) {
  setCurrentProfileInLocalStorage(JSON.stringify(newProfile));
  newProfile.language = checkLanguage(newProfile.language);
  if (this.localCache && this.localCache.auth) {
    cache.set("currentProfile", newProfile, {
      database: "auth",
      expiresIn: this.currentProfileExpirationTime
    });
  }
};

const get = async function() {
  if (this.localCache && this.localCache.auth) {
    currentProfile = await cache.get("currentProfile", { database: "auth" });
    setCurrentProfileInLocalStorage(JSON.stringify(currentProfile));
    if (!currentProfile && JSON.parse(localStorage.getItem("currentProfile"))) {
      currentProfile = JSON.parse(localStorage.getItem("currentProfile"));
    }
    if (currentProfile && currentProfile.language) {
      currentProfile.language = checkLanguage(currentProfile.language);
    }
  }
  return currentProfile;
};

const getToken = async function() {
  if (this.localCache && this.localCache.auth) {
    currentProfile = await cache.get("currentProfile", { database: "auth" });
    if (!currentProfile && JSON.parse(localStorage.getItem("currentProfile"))) {
      currentProfile = JSON.parse(localStorage.getItem("currentProfile"));
    }
  }

  return currentProfile && currentProfile.profileJwtToken;
};

const deleteProfile = async function() {
  await cache.remove("currentProfile", { database: "auth" });
};

const setCurrentProfileInLocalStorage = function(newCurrentProfile) {
  if (!newCurrentProfile) return;

  localStorage.setItem("currentProfile", newCurrentProfile);
  return;
};

export default { update, get, deleteProfile, getToken };
